import React, {useState, useEffect, useMemo, useCallback} from 'react';
import { useAppDispatch } from '../../stores/hook';
import PackModal from './GetStarted/Modals/PackModal';
import { getAvaliableChannelPacks } from '../functions/fetchGetStarted';
import translations from '../../text/get-started-translations.json';
import language from '../../utils/LanguageSettings';
import RenderSnA from '../functions/renderSnA';
import PackList from './GetStarted/components/PackList/PackList';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface AvailableChannelPacks {
    // className?: string;
    // combopacks: any[];
}

const AvailableChannelPacks: React.FC<AvailableChannelPacks> = () => {
    const pageTranslations = translations[language]; // Select the correct translations

    const [avaliableChannelPacks, setAvaliableChannelPacks] = useState<any>([]);
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [heading, setHeading] = useState<string | null>(null);
    const [bottom, setBottom] = useState<string | null>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const fetchData = async () => {
            const data = await getAvaliableChannelPacks(language);
            if (data) {
                setSeo(data.SEO || null);
                setGa(data.GA || null);
                setAvaliableChannelPacks(data.packs);
                setHeading(data.packs?.heading || null);
                setBottom(data.packs?.bottom || null);
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    const genres = [
        { key: "Sports", label: pageTranslations.Sports },
        { key: "Movie", label: pageTranslations.Movies },
        { key: "Entertainment", label: pageTranslations.Entertainment },
        { key: "FunnLearn", label: pageTranslations.FunnLearn },
        { key: "Infotainment", label: pageTranslations.Infotainment },
        { key: "ForeignLanguage", label: pageTranslations.ForeignLanguage },
        { key: "Adult", label: pageTranslations.Adult },
      ];

    const renderGenres = () => {
        return genres.map((genre, index) => {
            const genrePacks = avaliableChannelPacks[genre.key];
            if (!genrePacks || genrePacks?.data?.length === 0) {
                return null;
            }
            return <PackList key={genre.key} packs={genrePacks?.data} genre={genre} genreIsOpen={avaliableChannelPacks[genre.key+"Expand"]}/>;
        });
    };

    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }else{
        return (
            <>
                <RenderSnA seo={seo} ga={ga} />
                <section id="main-content">
                    <div className='container-fluid avalibale-pack'>
                        <div className='introduction-text'>
                            {heading ? (
                                <div>
                                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{heading}</ReactMarkdown>
                                </div>
                            ) : (
                                <h2></h2>
                            )}
                        </div>
                        <div className='mb-5'>
                            <div className='custom-accdn2 expandable'>
                                {renderGenres()}
                            </div>
                        </div>
                        <div className='bottom-remarks barlow-font py-4 mb-5 barlow-font'>
                            {bottom ? (
                                <div>
                                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{bottom}</ReactMarkdown>
                                </div>
                            ) : (
                                <h2></h2>
                            )}
                        </div>
                    </div>
                </section>
                <PackModal />
            </>
        );
    }
    
};

export default AvailableChannelPacks;